<template>
  <div style="background: #fff; display: flex; justify-content: center">
    <div class="xdRegister_css">
      <div class="main_box">
        <div class="user_css">
          <div class="titleBox">
            <div class="title">青梨绑定</div>
          </div>
          <div class="scanQrcode">
            <p>打开微信“扫一扫”</p>
            <p>扫描下方青梨小程序二维码，进入绑定页面</p>
            <div
              class="imgBox"
              
            >
              <div class="imgDiv" v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)">
                <!-- <div ></div> -->
                <img v-if="qrcodeImg" id="QrCodeImg" :src="qrcodeImg" alt="" />
                <div v-else
                  class="node_css"
                  style="cursor: pointer"
                  @click="getQrcode"
                >
                  <el-empty
                    :description="loading ? '加载中...' : '加载失败，点击刷新'"
                    :image-size="70"
                  ></el-empty>
                </div>
              </div>
            </div>
            <div class="QrCodeTips">微信 扫一扫 进入小程序</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      qrcodeImg: ``,
      img_code: "",
      loading: false,
    };
  },
  created() {
    if (this.$route.query.invitecode) {
      this.img_code = this.$route.query.invitecode;
    }
    this.getQrcode();
  },
  methods: {
    getQrcode() {
      this.loading = true;
      request
        .get("user/xxgc_applet_code/", {
          params: {
            invitecode: this.img_code,
          },
        })
        .then((res) => {
          this.loading = false;
          console.log(res);
          if(res.data.error_code == 0){
            this.qrcodeImg = res.data.data
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message({
            message: err,
            type: "error",
          });
        });
    },
  },
};
</script>

<style  lang="less" scoped>
.xdRegister_css {
  display: flex;
  justify-content: center;
  background-color: #6953da;
  background-size: 100%;
  width: 100%;
  max-width: 540px;
}
.main_box {
  min-height: 100vh;
  width: 100%;

  /* max-width: 800px; */
  /* background-image: url('../../assets/imgs/other/ba_.jpg');  
  background-size: contain; 
  background-position: center; 
  background-repeat: no-repeat;  */

  background: url("../../assets/imgs/other/ba_.jpg") no-repeat top center;
  //   width: 100%;
  background-size: contain;
  padding-top: 55%;
  padding-bottom: 2.5rem;
}
.user_css {
  margin-bottom: 3rem;
  width: 87%;
  margin: 0 auto;
  .titleBox {
    border: 2px solid #a475fe;
    padding: 3px;
    width: fit-content;
    margin: 0 auto;
    .title {
      background-color: #fff;
      font-weight: 600;
      font-size: 20px;
      color: #ae3cf2;
      text-align: center;
      padding: 5px 12px;
      letter-spacing: 2px;
    }
  }
}
.scanQrcode {
  background-color: #fff;
  border-radius: 16px; /* 1rem 转为 16px */
  padding: 16px; /* 1rem 转为 16px */
  margin: 45px 0; /* 1rem 转为 16px */
  box-shadow: 9.6px 9.6px #a066f8; /* 0.6rem 转为 9.6px */
  p {
    text-align: center;
    line-height: 25px;
    font-weight: 600;
  }
}
.imgBox {
  margin-top: 32px;
  .imgDiv {
    width: 55%; /* 9rem 转为 9 * 16px = 144px */
    margin: 0 auto;
    border: 12.8px solid #ead9ff; /* 0.8rem 转为 0.8 * 16px = 12.8px */
    border-radius: 5%; /* border-radius 使用百分比保持不变 */
  }
  #QrCodeImg {
    width: 100%;
  }
}
.QrCodeTips {
  color: #ab34f0;
  font-size: 16px;
  text-align: center;
  margin: 16px auto;
}
</style>